import React from "react";
import ReactEcharts from "echarts-for-react";
import getChartColorsArray from "./GetColors";

import { useTranslation } from "react-i18next";

const Doughnut = ({ dataColors, chartData }) => {
  const { t } = useTranslation();
  const doughnutEChartColors = getChartColorsArray(dataColors);
  const options = {
    toolbox: {
      show: false,
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
    },
    legend: {
      orient: "horizontal",
      x: "center",
      data: chartData?.map((item) => ({
        name: item.label,
      })),
      textStyle: {
        color: ["#8791af"],
      },
    },
    color: doughnutEChartColors,
    series: [
      {
        name: `${t("Total")}`,
        type: "pie",
        radius: ["50%", "70%"],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: false,
            position: "center",
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: "20",
              fontWeight: "bold",
            },
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: chartData?.map((item) => ({
          value: item?.value,
          name: item.label,
        })),
      },
    ],
  };

  return (
    <React.Fragment>
      <ReactEcharts height="150" option={options} />
    </React.Fragment>
  );
};
export default Doughnut;
